











































import Vue from 'vue';
import { get } from 'vuex-pathify';
import { mapActions } from 'vuex';

import { IQuoteServiceVariable, IQuoteTemplate } from '@/models';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
export default Vue.extend({
  components: { ErrorAlert },
  name: 'QuoteServiceVariableList',

  props: {
    errorMessage: String,
    detailErrorMessage: String
  },

  data: () => ({
    headers: [
      {
        text: '#',
        align: 'center',
        width: 50,
        sortable: false,
        value: 'index'
      },
      {
        text: 'Name',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      {
        text: 'Value',
        align: 'start',
        sortable: false,
        value: 'value'
      },
      {
        text: 'Service',
        align: 'start',
        sortable: false,
        value: 'service'
      },
      {
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ],
    loading: false
  }),

  computed: {
    quoteServiceVariables: get<IQuoteServiceVariable[]>(
      'quoteServiceVariable/getQuoteServiceVariables'
    ),

    getQuoteServiceTemplateById: get<(id: number) => IQuoteTemplate[]>(
      'quoteTemplate/getQuoteServiceTemplateById'
    )
  },

  mounted() {
    this.clearAllErrors();

    this.loading = true;
    this.fetchQuoteServiceVariables()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.$emit('update:detailErrorMessage', error.response.data.detail);
          }
        }
        this.$emit('update:errorMessage', ErrorManager.extractApiError(error));
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchQuoteServiceVariables:
        'quoteServiceVariable/fetchQuoteServiceVariables'
    }),

    clearAllErrors(): void {
      this.$emit('clearAllErrors');
    }
  }
});
